import React, { Component } from 'react';
import classnames from 'classnames/bind';
import idGenerator from 'react-id-generator';
import { bool, string, func, array, object, oneOfType, number } from 'prop-types';

import Dropdown from '../Dropdown/Dropdown';

import styles from './RadioButton.css';

class RadioButton extends Component {
  static propTypes = {
    className: string,
    disabled: bool,
    dropdownOptions: array,
    id: oneOfType([string, number]),
    isChecked: bool,
    label: string.isRequired,
    name: string.isRequired,
    onChange: func,
    onClick: func,
    value: string,
    variations: object,
    withDropdown: bool,
  };

  state = {
    isChecked: false,
  }

  static getDerivedStateFromProps(nextProps) {
    return {
      isChecked: nextProps.isChecked
    };
  }

  handleClick = () => {
    const { onClick } = this.props;

    this.setState({
      isChecked: true
    });

    onClick && onClick();
  }

  render() {
    const {
      className,
      disabled,
      value,
      withDropdown,
      dropdownOptions,
      onChange,
      label,
      id = idGenerator('input-radio-')
    } = this.props;

    const { isChecked } = this.state;

    return (
      <div className={classnames(styles.inputField, className, 'flex-inline flex-align-center')}>
        <input
          readOnly
          name={name}
          className={styles.input}
          type='radio'
          disabled={disabled}
          onClick={this.handleClick}
          id={id}
          checked={isChecked}
          value={value}
        />
        {
          withDropdown
            ? <Dropdown
                opts={dropdownOptions}
                disabled={disabled}
                className={styles.dropdown}
                onChange={onChange}
                />
            : <label htmlFor={id}>{label}</label>
        }
        <div className={styles.toggable}></div>
      </div>
    );
  }
}

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/inputs/RadioButton/RadioButton.js